// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ezTpm","rotation":"Loader_rotation__BSnwr"};